import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { SnTeam } from '@lib/api/entities';
import { snListStagger, snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnListBaseComponent } from '@lib/core';

@Component({
  selector: 'fs-team-list',
  templateUrl: './team-list.component.html',
  styleUrls: ['./team-list.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamListComponent extends SnListBaseComponent<SnTeam> {
  @Input()
  public selected: string = '';

  constructor() {
    super();
  }

  public trackBy(index: number, item: SnTeam): any {
    return item.id;
  }
}
